import PubSub from 'services/PubSub/';
import ExpressDeliveryService from 'services/ExpressDelivery';
import Moment from 'moment';
import {expressFlag} from 'config';

let currentCurtain = null;

const formatTime = (time) => {
    return Moment({
        hour: time.split(':')[0], 
        minute: time.split(':')[1]
    }).unix();
}

const validCurtain = (curtain) => {
    if(curtain) {
        const startTime = formatTime(curtain.starts_at);
        const currentTime = Moment(curtain.santiago_time).unix();
        const endTime = formatTime(curtain.ends_at);

        return !(currentTime >= startTime && currentTime <= endTime);
    }

    return false;
}

const _verifyCurtain = () => {

    ExpressDeliveryService.getCurtain().then(data => {
        let curtainAux = currentCurtain;
        if(data){
            data.map(curtain => {
                if(curtain.master){
                    curtainAux = validCurtain(curtain) ?  'master' : curtainAux;
                } else if(curtain.forced) {
                    curtainAux = 'forced';
                }
            });

            if(curtainAux !== currentCurtain){
                currentCurtain = curtainAux;
                PubSub.dispatch('express_curtain', currentCurtain);
            }
        }
    });
}

const CurtainService = {
    init: () => {
        if(expressFlag){
            _verifyCurtain();

            setInterval(_verifyCurtain, 1000 * 60);
        }
    },
    getCurtain: () => {
        return currentCurtain;
    }
}

export default CurtainService;
